export enum IconPosition {
  Leading = 'leading',
  Trailing = 'trailing',
}
